import * as z from 'zod/mini';

export const GlobalOptionsSchema = {
  // eslint-disable-next-line no-underscore-dangle
  locale: z._default(z.literal(['en', 'de', 'it', 'nl', 'fr', 'es']), 'en'),
  privacyPolicyUrl: z.string(),
  termsOfServiceUrl: z.string(),
  officeId: z.number(),
  departmentId: z.number(),
};
